import { Stack, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import * as styles from "./AuthDivider.styles";

export const AuthDivider = memo(function AuthDivider() {
  const { t } = useTranslation("auth");

  return (
    <Stack sx={styles.root}>
      <Stack sx={styles.line} />
      <Typography sx={styles.label}>{t("or")}</Typography>
      <Stack sx={styles.line} />
    </Stack>
  );
});
